const ResponsiveContainer = ({ children, className, noMargin }) => {
  return (
    <div
      className={`xl:max-w-screen-2xl lg:max-w-screen-xl md:max-w-screen-lg max-w-full mx-auto ${!noMargin ? 'px-3 md:px-4' : ''} lg:pt-0 ${className}`}
    >
      {children}
    </div>
  );
};

ResponsiveContainer.defaultProps = {
  className: '',
};

export default ResponsiveContainer;
